import PropTypes from 'prop-types';
export const feedbackModalPropTypes = {
  heading: PropTypes.shape({
    sm: PropTypes.string,
    lg: PropTypes.string
  }),
  text: PropTypes.string,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  form: PropTypes.shape({
    loading: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
      required: PropTypes.bool,
      items: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        required: PropTypes.bool
      })),
      placeholder: PropTypes.string
    })),
    submit: PropTypes.shape({
      label: PropTypes.string
    }).isRequired
  }),
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  classname: PropTypes.string
};